import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaUser,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaSignInAlt,
  FaExclamationTriangle,
} from "react-icons/fa";
import $ from "jquery";
import CommonModal from "Components/CommonModal";
import { signIn } from "JS/API";
import { setCookie, getCookie } from "JS/cookie";
import { catchError, commonModalSetting, enterFn } from "JS/common";
import logo from "Image/markpickLogo.svg";

const SignIn = () => {
  // State declarations
  const obj = {
    emptyBoth: false,
    emptyId: false,
    emptyPw: false,
    wrongId: false,
    wrongPw: false,
    retired: false,
  };
  
  const [userId, setUserId] = useState("");
  const [userPw, setUserPw] = useState("");
  const [check, setCheck] = useState(false);
  const [capsLock, setCapsLock] = useState(false);
  const [formCheck, setFormCheck] = useState(obj);
  const [alert, setAlert] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFocused, setIsFocused] = useState({ id: false, pw: false });
  
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });

  const navigate = useNavigate();

  // 스타일 정의
  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #319dff 0%, #ffffff 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    loginCard: {
      backgroundColor: '#ffffff',
      borderRadius: '20px',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(255, 255, 255, 0.05)',
      padding: '48px 40px',
      width: '100%',
      maxWidth: '420px',
      position: 'relative',
      overflow: 'hidden'
    },
    cardBackground: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '120px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      opacity: 0.05,
      borderRadius: '20px 20px 0 0'
    },
    logoContainer: {
      textAlign: 'center',
      marginBottom: '32px',
      position: 'relative',
      zIndex: 1
    },
    logo: {
      height: '48px',
      marginBottom: '16px'
    },
    title: {
    
      fontSize: '24px',
      fontWeight: '700',
      color: '#1e293b',
      margin: '10px 0 8px 0'
    },
    subtitle: {
      fontSize: '14px',
      color: '#64748b',
      margin: 0
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      marginBottom: '24px'
    },
    inputGroup: {
      position: 'relative'
    },
    inputWrapper: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },
    input: {
      width: '100%',
      padding: '16px 48px 16px 48px',
      border: '2px solid #e2e8f0',
      borderRadius: '12px',
      fontSize: '16px',
      backgroundColor: '#f8fafc',
      transition: 'all 0.3s ease',
      outline: 'none',
      boxSizing: 'border-box'
    },
    inputFocused: {
      borderColor: '#667eea',
      backgroundColor: '#ffffff',
      boxShadow: '0 0 0 4px rgba(102, 126, 234, 0.1)'
    },
    inputError: {
      borderColor: '#ef4444',
      backgroundColor: '#fef2f2'
    },
    inputIcon: {
      position: 'absolute',
      left: '16px',
      color: '#64748b',
      zIndex: 2,
      transition: 'color 0.3s ease'
    },
    inputIconFocused: {
      color: '#667eea'
    },
    passwordToggle: {
      position: 'absolute',
      right: '16px',
      background: 'none',
      border: 'none',
      color: '#64748b',
      cursor: 'pointer',
      padding: '4px',
      borderRadius: '4px',
      transition: 'color 0.3s ease',
      zIndex: 2
    },
    capsLockWarning: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '12px 16px',
      backgroundColor: '#fef3c7',
      color: '#92400e',
      borderRadius: '8px',
      fontSize: '14px',
      marginTop: '-8px',
      marginBottom: '8px'
    },
    checkboxContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginBottom: '24px'
    },
    checkbox: {
      width: '18px',
      height: '18px',
      accentColor: '#667eea'
    },
    checkboxLabel: {
      fontSize: '14px',
      color: '#64748b',
      cursor: 'pointer',
      userSelect: 'none'
    },
    divider: {
      border: 'none',
      height: '1px',
      backgroundColor: '#e2e8f0',
      margin: '24px 0'
    },
    loginButton: {
      width: '100%',
      padding: '16px',
      background: 'linear-gradient(135deg, #319dff 0%, #8EC9FF 100%)',
      color: '#ffffff',
      border: 'none',
      borderRadius: '12px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)'
    },
    loginButtonHover: {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 20px rgba(102, 126, 234, 0.6)'
    },
    loginButtonDisabled: {
      background: '#94a3b8',
      cursor: 'not-allowed',
      transform: 'none',
      boxShadow: 'none'
    },
    loadingSpinner: {
      width: '20px',
      height: '20px',
      border: '2px solid rgba(255, 255, 255, 0.3)',
      borderTop: '2px solid #ffffff',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    },
    securityBadge: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      marginTop: '24px',
      padding: '12px',
      backgroundColor: '#f1f5f9',
      borderRadius: '8px',
      fontSize: '12px',
      color: '#64748b'
    }
  };

  // 폼 검증 함수
  const checkForm = async (checkStr, bool) => {
    const obj = {
      emptyBoth: false,
      emptyId: false,
      emptyPw: false,
      wrongId: false,
      wrongPw: false,
      retired: false,
    };
    obj[checkStr] = bool;
    setFormCheck(obj);
  };

  // 로그인 함수
  const login = async () => {
    // 입력값 검증
    if (userId.trim() === "" && userPw.trim() === "")
      return checkForm("emptyBoth", true);
    else if (userId.trim() === "") return checkForm("emptyId", true);
    else if (userPw.trim() === "") return checkForm("emptyPw", true);

    setIsLoading(true);

    try {
      const result = await signIn(userId, userPw);
      if (typeof result === "object") {
        const { access_token, refresh_token, code } = result?.data;
        if (Number(code) === 200) return;
        
        setCookie("pickAdminMyToken", access_token, {
          path: "/",
          secure: false,
        });
        setCookie("pickAdminRfToken", refresh_token, {
          path: "/",
          secure: false,
        });
        localStorage.setItem(
          "admin_role",
          Number(code) === 300 ? "admin" : "super_admin"
        );
        
        // 아이디 저장 처리
        if (check) localStorage.setItem("save-id", userId);
        else localStorage.removeItem("save-id");
        
        navigate("/home");
      } else {
        // 에러 처리
        if (result === "wrongId") checkForm("wrongId", true);
        else if (result === `wrongPw`) checkForm("wrongPw", true);
        else if (result === "retired") checkForm("retired", true);
        else return await catchError(result, navigate, setAlertBox, setAlert);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // 초기화 효과
  useEffect(() => {
    if (getCookie("pickAdminMyToken")) navigate("/home");
    if (localStorage.getItem("save-id")) {
      setUserId(localStorage.getItem("save-id"));
      setCheck(true);
      setTimeout(() => $(".input_pw").focus(), 100);
    } else {
      setTimeout(() => $(".input_id").focus(), 100);
    }
    document.title = "마크픽 관리자 로그인";
  }, []);

  // 폼 검증 에러 처리
  useEffect(() => {
    let context;
    if (formCheck.emptyBoth) context = "아이디와 비밀번호를 입력해 주세요.";
    else if (formCheck.emptyId) context = "아이디를 입력해 주세요.";
    else if (formCheck.emptyPw) context = "비밀번호를 입력해 주세요.";
    else if (formCheck.wrongId) {
      context = `아이디 혹은 비밀번호가 일치하지 않습니다.<br/>다시 입력해 주세요.`;
      setUserId("");
      setUserPw("");
    } else if (formCheck.wrongPw) {
      context = `비밀번호가 일치하지 않습니다.<br/>다시 입력해 주세요.`;
      setUserPw("");
    } else if (formCheck.retired) {
      context = `탈퇴된 아이디입니다.`;
    } else context = "";
    
    if (context.trim() !== "")
      commonModalSetting(setAlertBox, true, "alert", context);
  }, [formCheck]);

  // 입력 스타일 결정
  const getInputStyle = (field, hasError) => {
    const baseStyle = styles.input;
    const focusedStyle = isFocused[field] ? styles.inputFocused : {};
    const errorStyle = hasError ? styles.inputError : {};
    
    return { ...baseStyle, ...focusedStyle, ...errorStyle };
  };

  const getIconStyle = (field) => {
    const baseStyle = styles.inputIcon;
    const focusedStyle = isFocused[field] ? styles.inputIconFocused : {};
    
    return { ...baseStyle, ...focusedStyle };
  };

  return (
    <div style={styles.container}>
      <div style={styles.loginCard}>
        <div style={styles.cardBackground}></div>
        
        {/* 로고 및 제목 */}
        <div style={styles.logoContainer}>
          <img src={logo} alt="마크픽 로고" style={styles.logo} />
          <h1 style={styles.title}>관리자 로그인</h1>
          <p style={styles.subtitle}>마크픽 관리자 시스템에 로그인하세요</p>
        </div>

        {/* 로그인 폼 */}
        <div style={styles.form}>
          {/* 아이디 입력 */}
          <div style={styles.inputGroup}>
            <div style={styles.inputWrapper}>
              <FaUser style={getIconStyle('id')} />
              <input
                type="text"
                placeholder="아이디를 입력하세요"
                autoComplete="off"
                className="input_id"
                value={userId}
                style={getInputStyle('id', formCheck.wrongId || formCheck.emptyId || formCheck.emptyBoth)}
                onFocus={() => setIsFocused(prev => ({ ...prev, id: true }))}
                onBlur={() => setIsFocused(prev => ({ ...prev, id: false }))}
                onKeyDown={(e) => {
                  if (!alertBox.bool) enterFn(e, login);
                  setCapsLock(e.getModifierState("CapsLock"));
                }}
                onChange={(e) => setUserId(e.target.value)}
              />
            </div>
          </div>

          {/* 비밀번호 입력 */}
          <div style={styles.inputGroup}>
            <div style={styles.inputWrapper}>
              <FaLock style={getIconStyle('pw')} />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="비밀번호를 입력하세요"
                autoComplete="off"
                className="input_pw"
                value={userPw}
                style={getInputStyle('pw', formCheck.wrongPw || formCheck.emptyPw || formCheck.emptyBoth)}
                onFocus={() => setIsFocused(prev => ({ ...prev, pw: true }))}
                onBlur={() => setIsFocused(prev => ({ ...prev, pw: false }))}
                onChange={(e) => setUserPw(e.target.value)}
                onKeyDown={(e) => {
                  if (!alertBox.bool) enterFn(e, login);
                  setCapsLock(e.getModifierState("CapsLock"));
                }}
              />
              <button
                type="button"
                style={styles.passwordToggle}
                onClick={() => setShowPassword(!showPassword)}
                onMouseEnter={(e) => e.target.style.color = '#667eea'}
                onMouseLeave={(e) => e.target.style.color = '#64748b'}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>
        </div>

        {/* CapsLock 경고 */}
        {capsLock && (
          <div style={styles.capsLockWarning}>
            <FaExclamationTriangle />
            <span><strong>CapsLock</strong>이 켜져 있습니다.</span>
          </div>
        )}

        {/* 아이디 저장 체크박스 */}
        <div style={styles.checkboxContainer}>
          <input
            type="checkbox"
            id="rememberId"
            checked={check}
            onChange={(e) => setCheck(e.target.checked)}
            style={styles.checkbox}
          />
          <label htmlFor="rememberId" style={styles.checkboxLabel}>
            아이디 저장
          </label>
        </div>

        <hr style={styles.divider} />

        {/* 로그인 버튼 */}
        <button
          onClick={login}
          disabled={isLoading}
          style={{
            ...styles.loginButton,
            ...(isLoading ? styles.loginButtonDisabled : {})
          }}
          onMouseEnter={(e) => {
            if (!isLoading) {
              Object.assign(e.target.style, styles.loginButtonHover);
            }
          }}
          onMouseLeave={(e) => {
            if (!isLoading) {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.4)';
            }
          }}
        >
          {isLoading ? (
            <>
              <div style={styles.loadingSpinner}></div>
              로그인 중...
            </>
          ) : (
            <>
              <FaSignInAlt />
              로그인
            </>
          )}
        </button>
      </div>

      {/* 모달 */}
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "logout") navigate("/");
            else return;
          }}
        />
      )}

      {/* CSS 애니메이션 */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .login-card {
          animation: fadeIn 0.6s ease-out;
        }

        @media (max-width: 480px) {
          .container {
            padding: 16px;
          }
          
          .login-card {
            padding: 32px 24px;
          }
          
          .logo {
            height: 40px;
          }
          
          .title {
            font-size: 20px;
          }
          
          .input {
            padding: 14px 40px 14px 40px;
            font-size: 16px;
          }
          
          .login-button {
            padding: 14px;
            font-size: 15px;
          }
        }

        .input:focus {
          outline: none;
        }

        .password-toggle:hover {
          background-color: rgba(102, 126, 234, 0.1);
        }

        .checkbox:focus {
          outline: 2px solid #667eea;
          outline-offset: 2px;
        }

        .login-button:focus {
          outline: 2px solid #667eea;
          outline-offset: 2px;
        }
      `}</style>
    </div>
  );
};

export default SignIn;